// redux/actions.js
export const SET_SELECTED_LOCATION = "SET_SELECTED_LOCATION";
export const SET_LOCATIONS = "SET_LOCATIONS";

export const setSelectedLocation = (location) => ({
  type: SET_SELECTED_LOCATION,
  payload: location,
});

export const setLocations = (locations) => ({
    type: SET_LOCATIONS,
    payload: locations,
});